import styled from "styled-components";
import { ScreenPlatform } from "@store/ducks/Screen/screen.type";
import { windowWidth } from "@styles/global";

interface StylesheetProps {
  platform: ScreenPlatform;
}

export const Container = styled.div<StylesheetProps>`
  padding-top: 85px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  overflow-y: scroll;
  position: relative;
  margin-top: ${(prop) => (prop.platform === "mobile" ? "5rem" : "0")};

  .report-controls {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-bottom: 10px;
  }

  .vehicle-filter-section {
    width: 100%;
    padding: 0 20px 20px 20px;

    .vehicle-filter-header {
      padding: 10px 0;

      .vehicle-filter-subtitle {
        font-size: 1.2rem;
        color: rgb(0 0 0 / 60%);
      }
    }

    .vehicle-selector {
      max-width: 350px;
    }
  }
`;
